import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    Renderer2,
    ViewChild,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { MenuService } from './app.menu.service';
import { AppSidebarComponent } from './app.sidebar.component';
import { AppTopbarComponent } from './app.topbar.component';
import { LayoutService, MenuMode } from './service/app.layout.service';
import { AuthService } from '@auth/auth.service';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { AppComponent } from '../app.component';
import { TokenService } from '@core/_services/token.service';
import { setCustomBskColorList, updateCssDefault } from '@core/_utils/tools.utils';
import { MenuStyle, tokenName } from '@documalis/_const/const';
import { CommonService } from '@service/common.service';
import { RequestTools } from '@service/request.tools';
import { NotificationService } from '@service/notification.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-layout',
    templateUrl: './app.layout.component.html',
})
export class AppLayoutComponent implements OnDestroy {

    overlayMenuOpenSubscription: Subscription;

    topbarMenuOpenSubscription: Subscription;

    menuProfileOpenSubscription: Subscription;

    menuOutsideClickListener: any;

    menuScrollListener: any;

    topbarMenuOutsideClickListener: any;

    menuProfileOutsideClickListener: any;

    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

    @ViewChild(AppTopbarComponent) appTopbar!: AppTopbarComponent;

    search = false;

    public userName = '';
    public clientName = '';
    public userFirstLastName = '';
    public documentClickListener: Function;

    constructor(private menuService: MenuService, 
        public layoutService: LayoutService, 
        public renderer: Renderer2, 
        private cd: ChangeDetectorRef,
        public authservice: AuthService,
        public menu: MenuServiceInt,
        public messagesService: MessagesService,
        private route: ActivatedRoute,
        private router: Router,
        private token: TokenService,
        private requestTools: RequestTools,
        private commonService: CommonService,        
        public app: AppComponent,
        private notifService: NotificationService,
        private _translate: TranslateService        
        ) {
        this.hideMenuProfile();
        
        this.overlayMenuOpenSubscription =
            this.layoutService.overlayOpen$.subscribe(() => {
            this.hideTopbarMenu();
            
            if (!this.menuOutsideClickListener) {
                    this.menuOutsideClickListener = this.renderer.listen(
                        'document',
                        'click',
                        (event) => {
                            const isOutsideClicked = !(
                                this.appSidebar.el.nativeElement.isSameNode(
                                    event.target
                                ) ||
                                this.appSidebar.el.nativeElement.contains(
                                    event.target
                                ) ||
                                this.appTopbar.menuButton.nativeElement.isSameNode(
                                    event.target
                                ) ||
                                this.appTopbar.menuButton.nativeElement.contains(
                                    event.target
                                )
                            );
                    if (isOutsideClicked) {
                        this.hideMenu();
                    }
                        }
                    );
            }

                if (
                    (this.layoutService.isHorizontal() ||
                        this.layoutService.isSlim() ||
                        this.layoutService.isSlimPlus()) &&
                    !this.menuScrollListener
                ) {
                    this.menuScrollListener = this.renderer.listen(
                        this.appSidebar.menuContainer.nativeElement,
                        'scroll',
                        (event) => {
                    if (this.layoutService.isDesktop()) {
                        this.hideMenu();
                    }
                        }
                    );
            }

            if (this.layoutService.state.staticMenuMobileActive) {
                this.blockBodyScroll();
            }
        });

        this.topbarMenuOpenSubscription =
            this.layoutService.topbarMenuOpen$.subscribe(() => {
            if (!this.topbarMenuOutsideClickListener) {
                    this.topbarMenuOutsideClickListener = this.renderer.listen(
                        'document',
                        'click',
                        (event) => {
                            const isOutsideClicked = !(
                                this.appTopbar.el.nativeElement.isSameNode(
                                    event.target
                                ) ||
                                this.appTopbar.el.nativeElement.contains(
                                    event.target
                                ) ||
                                this.appTopbar.mobileMenuButton.nativeElement.isSameNode(
                                    event.target
                                ) ||
                                this.appTopbar.mobileMenuButton.nativeElement.contains(
                                    event.target
                                )
                            );
                    if (isOutsideClicked) {
                        this.hideTopbarMenu();
                    }
                        }
                    );
            }

            if (this.layoutService.state.staticMenuMobileActive) {
                this.blockBodyScroll();
            }
        });

        this.menuProfileOpenSubscription =
            this.layoutService.menuProfileOpen$.subscribe(() => {
            this.hideMenu();

            if (!this.menuProfileOutsideClickListener) {
                    this.menuProfileOutsideClickListener = this.renderer.listen(
                        'document',
                        'click',
                        (event) => {
                            const isOutsideClicked = !(
                                this.appSidebar.menuProfile.el.nativeElement.isSameNode(
                                    event.target
                                ) ||
                                this.appSidebar.menuProfile.el.nativeElement.contains(
                                    event.target
                                )
                            );
                    if (isOutsideClicked) {
                        this.hideMenuProfile();
                    }
                        }
                    );
            }
        });

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                this.hideMenu();
                this.hideTopbarMenu();
                this.hideMenuProfile();
            });
    }

    async ngOnInit() {
        // this.menuActive = this.isStatic() && !this.isMobile();
        let wRes;
        let wBasketList;
        let wBasketListAll;
        this.userName = this.token.getUserName();
        if (this.userName !== undefined) {            
            this.menu.userName = this.token.getFirstLastName();
        }
        this.userFirstLastName = this.token.getFirstLastName();

        let wPref: any;
        wPref = JSON.parse(localStorage.getItem('preference'));
        if (wPref !== null) {
            try {
                this.menu.changeTheme(wPref.theme);
                this.menu.topBarTheme = wPref.topBarTheme;
                this.menu.menuTheme = wPref.menuTheme;
                this.menu.changeScale(wPref.scale);
                // Si aucune préférence de menu, on prend la valeur du type de menu
                // Si une préference de menu enregistrée, la valeur enregistrée étant l'index, 
                // on récupère valeur du type de menu par rapport à l'index (historique)
                if (<MenuMode>MenuStyle[wPref.menuStyle] === undefined) {
                    this.layoutService.config().menuMode = <MenuMode>wPref.menuStyle;
                } else {
                    this.layoutService.config().menuMode = <MenuMode>MenuStyle[wPref.menuStyle];
                }
                this.layoutService.config().menuTheme = this.menu.menuTheme;
                this.layoutService.config().topbarTheme = this.menu.topBarTheme;                
            } catch (e) {
                console.log('AppLayoutComponent ngOnInit catch', e);
            }
        }

        let wIntern: any;
        wIntern = JSON.parse(atob(localStorage.getItem('intern')));
        wBasketListAll = await this.requestTools.execGetBasketList();
        if (wBasketListAll.Status !== 'ERROR') {
            wBasketList = this.requestTools.getBskTransList(wBasketListAll);
            setCustomBskColorList(wIntern, wBasketList);
            wBasketList = this.requestTools.getBskTransList(wBasketListAll, 'group');
            setCustomBskColorList(wIntern, wBasketList);
            updateCssDefault(wIntern);
        } else {
            this.messagesService.addErrorMsg(this._translate.instant('Load_Data_KO'));
        }

        window.addEventListener('storage', async (e) => {
            if (e.key === tokenName) {
                if (e.oldValue === null && e.newValue !== null) {
                    this.router.navigate(['login']);
                } else if (e.oldValue !== null && e.newValue === null) {
                    this.router.navigate(['login']);
                }
            } else {
                if (e.key === null) {
                    this.router.navigate(['login']);
                }
            }
        });
        (<any>window).pdfWorkerSrc = '/assets/worker/pdf.worker.min.js';        
        this.verifyNotify();
    }

    ngAfterViewInit() {
        if (this.token.currentToken !== '') {
            this.verifyReset();
        }
    }

    private verifyNotify() {
        if (this.notifService.timerSubcribe === undefined || this.notifService.timerSubcribe === null) {
            this.notifService.initialize();
        }
    }

    private async verifyReset() {
        let wResReset;
        wResReset = await this.requestTools.verifyResetPwd(this.authservice.getUser());
        if (wResReset.status === true) {
            if (wResReset.data.data === true) {
                this.commonService.resetPass = true;
                this.router.navigate(['page-reset-pwd']);
            }
        } else {
            if (wResReset.Status === 'EXPIRED') {
                this.commonService.clearMessage();
                this.app.languageIsLoaded = false;
                this.router.navigate(['login']);
            }
        }
    }

    onSearchKeydown(event) {
        if (event.keyCode == 27) {
            this.search = false;
        }
    }


    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(
                new RegExp(
                    '(^|\\b)' +
                        'blocked-scroll'.split(' ').join('|') +
                        '(\\b|$)',
                    'gi'
                ),
                ' '
            );
        }
    }

    hideMenu() {
        this.layoutService.state.overlayMenuActive = false;
        this.layoutService.state.staticMenuMobileActive = false;
        this.layoutService.state.menuHoverActive = false;
        this.menuService.reset();
        
        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
            this.menuOutsideClickListener = null;
        }

        if (this.menuScrollListener) {
            this.menuScrollListener();
            this.menuScrollListener = null;
        }
        this.unblockBodyScroll();
    }

    hideTopbarMenu() {
        this.layoutService.state.topbarMenuActive = false;
        
        if (this.topbarMenuOutsideClickListener) {
            this.topbarMenuOutsideClickListener();
            this.topbarMenuOutsideClickListener = null;
        }
    }

    hideMenuProfile() {
        this.layoutService.state.menuProfileActive = false;
        
        if (this.menuProfileOutsideClickListener) {
            this.menuProfileOutsideClickListener();
            this.menuProfileOutsideClickListener = null;
        }
    }

    get containerClass() {
        let styleClass: {[key: string]: any} = {
            'layout-overlay':
                this.layoutService.config().menuMode === 'overlay',
            'layout-static': this.layoutService.config().menuMode === 'static',
            'layout-slim': this.layoutService.config().menuMode === 'slim',
            'layout-slim-plus':
                this.layoutService.config().menuMode === 'slim-plus',
            'layout-horizontal':
                this.layoutService.config().menuMode === 'horizontal',
            'layout-reveal': this.layoutService.config().menuMode === 'reveal',
            'layout-drawer': this.layoutService.config().menuMode === 'drawer',
            'p-input-filled':
                this.layoutService.config().inputStyle === 'filled',
            'p-ripple-disabled': !this.layoutService.config().ripple,
            'layout-static-inactive':
                this.layoutService.state.staticMenuDesktopInactive &&
                this.layoutService.config().menuMode === 'static',
            'layout-overlay-active': this.layoutService.state.overlayMenuActive,
            'layout-mobile-active':
                this.layoutService.state.staticMenuMobileActive,
            'layout-topbar-menu-active':
                this.layoutService.state.topbarMenuActive,
            'layout-menu-profile-active':
                this.layoutService.state.menuProfileActive,
            'layout-sidebar-active': this.layoutService.state.sidebarActive,
            'layout-sidebar-anchored': this.layoutService.state.anchored,
        };

        styleClass['layout-topbar-' + this.layoutService.config().topbarTheme] =
            true;
        styleClass['layout-menu-' + this.layoutService.config().menuTheme] =
            true;
        styleClass[
            'layout-menu-profile-' +
                this.layoutService.config().menuProfilePosition
        ] = true;
        return styleClass;
    }

    ngOnDestroy() {
        if (this.overlayMenuOpenSubscription) {
            this.overlayMenuOpenSubscription.unsubscribe();
        }

        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
        }

        this.notifService.destroy();
    }

}
